var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"puzzles-item-wrapper"},[_c('div',{staticClass:"puzzles-inner puzzles-inner-my",class:{
        'puzzles-select-mode': _vm.selected.length > 0,
        'puzzles-inner-open': _vm.showContext
    }},[_c('div',{ref:"contextButton",staticClass:"puzzles-image puzzles-image-my",style:({
            'background-image':
                _vm.myPuzzle.blurred ?
                    'url(' + _vm.myPuzzle.blurred + ')' :
                    ''
        }),on:{"click":_vm.handleOpenModal}},[_c('div',{staticClass:"puzzles-image-original",style:({
                'background-image':
                    _vm.myPuzzle.image ?
                        'url(' + _vm.myPuzzle.image + ')' :
                        ''
            })})]),_vm._v(" "),(_vm.editingMode)?_c('div',{staticClass:"puzzles-select-button",class:{ 'puzzles-select-selected': _vm.selected.indexOf(_vm.myPuzzle.id) >= 0 },on:{"click":_vm.select}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }